import type { Event as BrowserEvent, EventHint as BrowserEventHint } from '@sentry/types'
import type { ErrorEvent as NodeErrorEvent, EventHint as NodeEventHint } from '@sentry/node'
import { EXCLUDE_LIST } from '@/utils/constants/sentry'

type CombinedEventHint = BrowserEventHint | NodeEventHint
type MinimalEvent = {
  exception?: { values?: Array<{ value?: string | null | undefined }> }
}

const isNonError = (event: MinimalEvent) => {
  const list = EXCLUDE_LIST.find((value) => {
    let exception = event?.exception?.values?.[0]?.value?.trim()
    exception = exception?.replace(/ +(?= )/g, '')

    return exception?.startsWith(value)
  })

  return !list
}

export function beforeSend(
  sentryEvent: NodeErrorEvent,
  sentryHint: NodeEventHint
): NodeErrorEvent | PromiseLike<NodeErrorEvent | null> | null

export function beforeSend(
  sentryEvent: BrowserEvent,
  sentryHint: BrowserEventHint
): BrowserEvent | PromiseLike<BrowserEvent | null> | null

export function beforeSend<T extends BrowserEvent | NodeErrorEvent>(
  sentryEvent: T,
  sentryHint: CombinedEventHint
): T | PromiseLike<T | null> | null {
  try {
    if (!sentryHint.originalException || isNonError(sentryEvent)) {
      return null
    }
  } catch (error) {
    console.warn('[sentry] Failed to identify originalException', error)
  }

  return sentryEvent
}
